import React, { useState } from 'react';
import API from '../utils/api';
import { Link } from 'react-router-dom';

export default function Login({ onLogin }) {
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!form.username || !form.password) { setError('请输入账号和密码'); return; }
    setLoading(true); setError('');
    try {
      const res = await API.post('/users/login', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      onLogin(res.data.user);
    } catch (err) {
      setError(err.response?.data?.message || '登录失败');
    } finally { setLoading(false); }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src="/logo.png" alt="logo" style={styles.logo} onError={e => { e.target.style.display='none'; }} />
        <div style={styles.logoText}>☁️</div>
        <h2 style={styles.title}>云彩环境</h2>
        <p style={styles.subtitle}>物业管理系统</p>
        <input style={styles.input} placeholder="账号"
          value={form.username}
          onChange={e => setForm({...form, username: e.target.value})}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        <input style={styles.input} type="password" placeholder="密码"
          value={form.password}
          onChange={e => setForm({...form, password: e.target.value})}
          onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
        {error && <p style={styles.error}>{error}</p>}
        <button style={{...styles.btn, opacity: loading ? 0.7 : 1}}
          onClick={handleSubmit} disabled={loading}>
          {loading ? '登录中...' : '登 录'}
        </button>
        <p style={styles.footer}>业主用户？<Link to="/register" style={{color:'#1a4a8a',fontWeight:600}}>立即注册</Link></p>
        <p style={{...styles.footer,marginTop:'8px'}}>物业员工？<Link to="/staff-register" style={{color:'#722ed1',fontWeight:600}}>员工注册</Link></p>
        <p style={styles.footer}>云彩环境 物业管理</p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', background: 'linear-gradient(135deg, #1a4a8a 0%, #2d7dd2 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' },
  card: { background: '#fff', borderRadius: '16px', padding: '40px 30px', width: '100%', maxWidth: '360px', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', textAlign: 'center' },
  logo: { width: '80px', height: '80px', objectFit: 'contain', marginBottom: '8px' },
  logoText: { fontSize: '48px', marginBottom: '4px' },
  title: { margin: '0 0 4px', fontSize: '24px', color: '#1a4a8a', fontWeight: 800 },
  subtitle: { margin: '0 0 28px', color: '#888', fontSize: '14px' },
  input: { display: 'block', width: '100%', padding: '12px 16px', marginBottom: '14px', border: '1.5px solid #e0e0e0', borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '14px', background: 'linear-gradient(90deg, #1a4a8a, #2d7dd2)', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '17px', fontWeight: 600, cursor: 'pointer', marginTop: '6px' },
  error: { color: '#ff4d4f', fontSize: '14px', margin: '0 0 10px' },
  footer: { marginTop: '20px', fontSize: '12px', color: '#ccc' }
};
